const formatSaveRequest = formValues => {
  if (formValues.property) {
    formValues.address = formValues.property
  }
  formValues.loan_duration_months = formValues.loan_duration * 12
  return formValues
}

export default formatSaveRequest
